import ICarLoanOrder from "./ICarLoanOrder";
import IRequiredDocumentDetail from "@/module/main/dto/IRequiredDocumentDetail";

export class CarLoanOrder implements ICarLoanOrder
{
    public readonly requiredDocuments?: IRequiredDocumentDetail[];
    public readonly calculationId?: string;
    public readonly dealerId?: string;

    constructor(props: ICarLoanOrder)
    {
        this.requiredDocuments = props.requiredDocuments;
        this.calculationId = props.calculationId;
        this.dealerId = props.dealerId;
    }
}
